import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { JWTUser } from 'Model';
import { PlanDto } from 'app/models/dto';
import { DashboardService } from 'app/services/dashboard.service';
import { PaymentService } from 'app/services/payment.service';
import { UtilserviceService } from 'app/services/utilservice.service';
import { UpgradeComponent } from 'app/upgrade/upgrade.component';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
const transactionlisttext: string = 'Transaction List';
const attemptsHistory: string = 'Attempts History';
const paymentsHistory: string = 'Payments History';
const dashboardtext: string = 'Dashboard';
const morecredittext: string = 'Buy more Credits';
const subjectcombotext: string = 'Subject Combination';
export const ROUTES: RouteInfo[] = [
  { path: '/dashboard', title: dashboardtext, icon: 'pe-7s-graph', class: '' },
  { path: '/transactions', title: transactionlisttext, icon: 'pe-7s-note2', class: '' },
  { path: '/attempts-history', title: attemptsHistory, icon: 'pe-7s-note2', class: '' },
  { path: '/payments-history', title: paymentsHistory, icon: 'pe-7s-note2', class: '' },
  { path: '/upgrade', title: morecredittext, icon: 'pe-7s-rocket', class: 'active-pro' },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css', '../subjectcombination/subjectcombination.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  menuItems: any[];
  sidebarVisible: boolean;
  isSubjectPopupVisible: boolean = true;
  dismissable: boolean = true;
  user: JWTUser;
  isPlanPopupVisible: boolean = false;
  plan: PlanDto = {
    id: 0,
    title: '',
    credits: 0,
    price: 0,
    validity: 0,
    validityType: '',
    currency: ''
  }
  paymentWindow: Window;
  disableBtn: boolean = false;
  windowMessageReceivedHandler;
  isPopupVisible: boolean = true;
  appName: string;
  logo: string;
  constructor(private util: UtilserviceService, private router: Router, private paymentServices: PaymentService, private toastr: ToastrService, private dashboardService: DashboardService) {
  }
  ngOnDestroy(): void {
    if (this.windowMessageReceivedHandler) {
      window.removeEventListener('message', this.windowMessageReceivedHandler);
    }  
  }
  ngOnInit() {
    this.windowMessageReceivedHandler = this.windowMessageReceived.bind(this);
    window.addEventListener('message', this.windowMessageReceivedHandler);
    this.appName = this.util.getDomainEnviroment().appName;
    this.logo = this.util.getDomainEnviroment().landingPageLogo;
    this.user = JSON.parse(this.util.getCurrentUser()) as JWTUser;
    this.isPopupVisible = !this.user.isEnabled;

    //adds this nav only when subject combo is activated and user is enabled
    let subjectComboNav = ROUTES.find(r => r.title === subjectcombotext);    
    if (this.user.allowCombo && this.user.isEnabled && subjectComboNav == undefined) { //subjectComboNav checking for undefined would prevent duplicate Nav from being created
      ROUTES.push({ path: null, title: subjectcombotext, icon: 'pe-7s-note2', class: '' })
    }
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    // determines if popup is dismissable
    if (this.user.isEnabled && this.user.allowCombo && this.user.selectedSubjects.length == 0) {
      this.isSubjectPopupVisible = true;
      this.dismissable = false;
    }
    else {
      this.isSubjectPopupVisible = false;
      this.dismissable = true;

    }
    this.plan = this.util.getSelectedPlan();
    if (this.user && this.plan?.id) {
      //when the user is activated and the user has selected a subject combination
      if (this.user.isEnabled && (this.user.allowCombo && this.user.maxCombo > 0 && this.user.selectedSubjects.length > 0)) {
        this.isPlanPopupVisible = true;
      }
      //when the user is activated and the user no subject combination required
      if (this.user.isEnabled && !this.user.allowCombo && this.plan?.id) {
        this.isPlanPopupVisible = true;
      }
    }
  }

  isMobileMenu() {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  };

  handleMenuItemClick(menuItem: RouteInfo) {
    if (menuItem.title == subjectcombotext) {
      this.isSubjectPopupVisible = true;
    }
    else {
      if (this.dismissable)
        this.isSubjectPopupVisible = false;
    }
    this.dashboardService.emitSignal();
  }

  onClose(data: any) {
    this.isSubjectPopupVisible = data;
    this.dismissable = true;
  }
  close() {
    this.isPlanPopupVisible = false;
    this.util.clearSelectedPlan();
  }
  async buy() {
    this.disableBtn = true;
    let user = JSON.parse(this.util.getCurrentUser()) as JWTUser;
    let data = {
      "PlanId": this.plan?.id,
      "Email": user.email,
      "Domain": user.domain
    }
    try {
      let res = await this.paymentServices.buyPlan(data);
      this.openPaymentWindow(res.url);
    } finally {
      this.close()
    }
  }
  openPaymentWindow(url) {
    this.close();
    this.closePaymentWindow();
    this.paymentWindow = window.open(`/external?url=${encodeURI(url)}`);
  }
  logOut(){
    this.util.removeUserAuth();
    this.router.navigateByUrl('/login');
    }

  closePaymentWindow() {
    if (this.paymentWindow) {
      this.paymentWindow.close();
    }
    this.disableBtn = false;
    this.paymentWindow = null;
  }
  async windowMessageReceived(event) {
    if (event.data.type == 'paymentdone') {
      if (event.data.responsecode == '0') {
        this.toastr.success('Payment Successful');
        window.location.assign("/dashboard");
      }
      else {
        if (isNaN(event.data.responsecode)) {
          this.toastr.error(event.data.reason, 'Payment Error', { timeOut: 0, closeButton: true });
        }
        else {
          this.toastr.warning(event.data.reason, 'Payment Processing...', { timeOut: 0, closeButton: true });
        }
      }
      this.closePaymentWindow();
    }
  }
}
